import React from "react";

import { dispatch } from "@rematch/core";
import { push } from "react-router-redux";
import {
  organizationService,
  subOrganizationService,
  subOrganizationByRoleService,
  suborganizationsExportService,
  suborganizationsImportService,
  checkSuborganizationBeforeDeleteService,
  setDefaultWorkspaceService,
  setActiveWorkspaceService,
  accountUserWorkspacesService,
  managerDashboardCountService,
  workspaceOwnerDashboardCountervice,
  changeRoleTeamService,
  accountUsersService,
} from "../../services/feathers.service";
import { toastr } from "react-redux-toastr";

const initialState = {
  subOrgError: null,
  subOrgs: null,
  subOrgsResourcePane: [],
  selectedSubOrg: null,
  showResourecePaneFlag: null,
  activePage: 1,
  activePaneIndex:null,
  landingPageFlag: false,
  organizationCountData: {},
  teamToExport: [],
  isDeleteDisabled: false,
  teamList: [],
  createdTeam:{},
  orgTeams: {},
  orgUsers: [],
};

export default {
  state: initialState,
  reducers: {
    setError(state, payload) {
      return {
        ...state,
        subOrgError: payload,
      };
    },
    setSubOrg(state, payload) {
      return {
        ...state,
        subOrgs: payload,
      };
    },
    setSelectedSubOrg(state, payload) {
      return {
        ...state,
        selectedSubOrg: payload,
      };
    },
    setSubOrgForResourcePane(state, payload) {
      return {
        ...state,
        subOrgsResourcePane: payload,
      };
    },
    showResourecePaneFlagSet(state, payload) {
      return {
        ...state,
        showResourecePaneFlag: payload,
      };
    },
    setOrgUsers(state, payload) {
      return {
        ...state,
        orgUsers: payload,
      };
    },

    setActivePage(state, payload) {
      return {
        ...state,
        activePage: payload,
      };
    },
    setActivePaneIndex(state, payload) {
      return {
        ...state,
        activePaneIndex: payload,
      };
    },
    setCreatedTeam(state,payload){
      return {
        ...state,
        createdTeam : payload,
      }
    },
    setLadingPage(state, payload) {
      return {
        ...state,
        landingPageFlag: payload,
      };
    },
    setOrganizationCountData(state, payload) {
      return {
        ...state,
        organizationCountData: payload,
      };
    },
    showDeleteDisabledBtn(state, payload) {
      return {
        ...state,
        isDeleteDisabled: payload,
      };
    },
    getTeamDataToExport(state, payload = {}) {
      return {
        ...state,
        teamToExport: payload,
      };
    },
    setTeamList(state, payload) {
      return {
        ...state,
        teamList: payload,
      };
    },
    getOrgTeams(state, payload = {}) {
      return {
        ...state,
        orgTeams: payload,
      };
    },
    clear() {
      return initialState;
    },
  },
  effects: {
    //for add Suborganization
    async addSubOrganizationAsync(payload) {
      try {
        const addSubOrg = await subOrganizationService.create(payload);
        toastr.success("Message", addSubOrg.name + " team added successfully");
        dispatch.community.addBreadCrumbOps("");
        dispatch.organizationTab.getOrgnizationUnitAsync(
          addSubOrg.organizationId
        );
        if (addSubOrg.organizationId === addSubOrg.parentOrganizationId) {
          dispatch.organizationUnit.getAssignedSubOrgAsync({
            organizationId: addSubOrg.parentOrganizationId,
            accountId: addSubOrg.accountId,
          });
          return dispatch(
            push(
              `/app/${payload.accountId}/_ws/${payload.organizationId}/_cm/team/${payload.organizationId}`
            )
          );
        } else {
          dispatch.organizationUnit.getSubOrgByParentIdAsync({
            teamId: addSubOrg.parentOrganizationId,
          });
          return dispatch(
            push(
              `/app/${addSubOrg.accountId}/_ws/${addSubOrg.organizationId}/_cm/team/${payload.parentOrganizationId}`
            )
          );
        }
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        let errdesc;
        if (err.code === 409) {
          errdesc = "Team with same name already exists";
        } else {
          errdesc = "Failed to add";
        }
        toastr.error("Message", errdesc);
        throw err;
      }
    },
    async createTeam(payload,state){
      payload.organizationId = state.app.selectedOrganisation.id.toString()
      payload.accountId = payload.accountId;
        payload.parentOrganizationId = state.app.selectedOrganisation.id.toString();
        payload.slug = payload.name.toLowerCase().trim();
        payload.summary = payload.name;
        payload.members = [{
            role: "Manager",
            accountUserId: state.app.user._id
        }]
      const addSubOrg = await subOrganizationService.create(payload);
      toastr.success("Message", addSubOrg.name + " team added successfully");
      dispatch.organizationUnit.getAssignedSubOrgAsync({
        organizationId: addSubOrg.parentOrganizationId,
        accountId: addSubOrg.accountId,
      });
      dispatch.organizationUnit.setCreatedTeam(addSubOrg);
    },
    async getSubOrgByParentIdAsync(payload) {
      try {
        let query = {
          teamId: payload.teamId,
          // $limit: payload.query.$limit,
          // $skip: payload.query.$skip,
          // $sort: payload.query.$sort,
          // $or: payload.query.$or
        };
        const subOrgs = await subOrganizationByRoleService.find({
          query: query,
        });
        dispatch.organizationUnit.setSubOrgData(subOrgs);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
      }
    },
    async getAssignedSubOrgAsync(payload, state) {
      try {
        let query = {
          // id: payload.organizationId,
          // accountId: payload.accountId,
          role: state.app.selectedOrganisation.role,
          // $limit: payload.query.$limit,
          // $skip: payload.query.$skip,
          // $sort: payload.query.$sort,
          // $or: payload.query.$or
        };
        const subOrgs = await subOrganizationByRoleService.find({
          query: query,
        });
        dispatch.organizationUnit.setSubOrgData(subOrgs);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
      }
    },
    setSubOrgData(payload) {
      dispatch.organizationUnit.setSubOrg(payload);
    },
    async isSuborgAvailable(payload, state) {
      try {
        const subOrg = await subOrganizationService.get(payload.id);
        dispatch.community.addMainAreaContext("ORGANIZATION");
        dispatch.community.setAddUserContextData("Teams");
        dispatch.users.storeUnitId(subOrg._id);
        await dispatch(
          push(
            `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_cm/team/${payload.id}`
          )
        );
      } catch (e) {
        if (state.home.redirectFromDashboard) {
          dispatch.home.eventDetailsNotFound(true);
        }
      }
    },

    addSelectedSubOrg(subOrg) {
      dispatch.organizationUnit.setSelectedSubOrg(subOrg);
    },
    async editSubOrganizationNameAsync(payload) {
      try {
        await subOrganizationService.patch(payload._id, {
          $set: {
            name: payload.name,
            slug: payload.slug,
            oldName: payload.oldName,
          },
        });
        dispatch.organizationTab.getOrgnizationUnitAsync(
          payload.organizationId
        );
        await dispatch.organizationUnit.updateTeamsList({
          _id: payload._id,
          data: { name: payload.name },
        });
        toastr.success("Message", "Team Updated Successfully");
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        toastr.error("Message", "Team with same name already exists.");
        throw err;
      }
    },
    updateTeamsList(payload, state) {
      for (let pack of state.organizationUnit.subOrgs.data) {
        if (pack._id.toString() === payload._id.toString()) {
          for (let key of Object.keys(payload.data)) {
            pack[key] = payload.data[key];
          }

          break;
        }
      }
      dispatch.organizationUnit.setSubOrgData(state.organizationUnit.subOrgs);
    },

    async editSubOrganizationDescriptionAsync(payload) {
      try {
        await subOrganizationService.patch(payload._id, {
          $set: { summary: payload.summary },
        });
        await dispatch.organizationUnit.updateTeamsList({
          _id: payload._id,
          data: { summary: payload.summary },
        });
        toastr.success("Message", "Team Updated Successfully");
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        toastr.error("Message", "Team with same name already exists.");
        throw err;
      }
    },
    // Below change is made for KLM-8949
    async updateSuborgMetadata(payload) {
      try {
        await subOrganizationService.patch(payload._id, {
          $set: { metaData: payload.metaData },
        });
      } catch (error) {
        console.log("Error in updating Metadata", error);
        throw error;
      }
    },
    async getSubOrgResourcePaneAsync(payload) {
      try {
        const subOrgs = await subOrganizationService.find({
          query: {
            parentOrganizationId: payload,
            active: true,
            $sort: { createdAt: 1 },
          },
        });
        dispatch.organizationUnit.setSubOrgForResourcePane(subOrgs);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
      }
    },
    async deleteSubOrganizationAsync(payload) {
      payload.type = "deteleSubOrg";
      try {
        await subOrganizationService.patch(payload._id, payload);
        await dispatch.organizationUnit.getSubOrgResourcePaneAsync(
          payload.orgUniqueId
        ); //for resource pane update
        await dispatch.organizationTab.getOrgnizationUnitAsync(
          payload.organizationId
        ); //for left tree update

        //for card count update
        if (
          payload.selectedSubOrg.organizationId ===
          payload.selectedSubOrg.parentOrganizationId
        ) {
          await dispatch.organizationUnit.getAssignedSubOrgAsync({
            organizationId: payload.selectedSubOrg.parentOrganizationId,
            accountId: payload.accountId,
          });
        } else {
          await dispatch.organizationUnit.getSubOrgByParentIdAsync({
            teamId: payload.selectedSubOrg.parentOrganizationId,
          });
        }
        toastr.success("Message", payload.name + " Team deleted successfully");
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        toastr.error("Message", "Failed to delete ");
        throw err;
      }
    },
    async deleteSubOrganizationMainAsync(payload) {
      payload.type = "deteleSubOrg";
      // Below changes are made for KLM-9065
      try {
        await subOrganizationService.patch(payload._id, payload);
        await dispatch.organizationUnit.getAssignedSubOrgAsync({
          organizationId: payload.parentOrganizationId,
          accountId: payload.accountId,
        });
        await dispatch.organizationUnit.getOrgByIdAsync(
          payload.parentOrganizationId
        );
        await dispatch.organizationUnit.showResourecePane(null);
        await dispatch.organizationTab.getOrgnizationUnitAsync(
          payload.organizationId
        );
        await dispatch.users.storeUnitId(payload.parentOrganizationId);
        await dispatch.organizationTab.getUsersTreeAsync({
          id: payload.organizationId,
          accountId: payload.accountId,
        });
        toastr.success("Message", payload.name + " Team deleted successfully");
        dispatch(
          push(
            `/app/${payload.accountId}/_ws/${payload.organizationId}/_cm/team/${payload.parentOrganizationId}`
          )
        );
        // await subOrganizationService.remove(payload._id, payload); //change patch to remove
        // if (payload.organizationId === payload.parentOrganizationId) {
        //   await dispatch.organizationUnit.getAssignedSubOrgAsync({
        //     organizationId: payload.parentOrganizationId,
        //     accountId: payload.accountId,
        //   });
        //   await dispatch.organizationUnit.getOrgByIdAsync(
        //     payload.parentOrganizationId
        //   );
        // } else {
        //   await dispatch.organizationUnit.getSubOrgByParentIdAsync({
        //     teamId: payload.parentOrganizationId,
        //   });
        //   await dispatch.organizationUnit.getSubOrgByIdAsync(
        //     payload.parentOrganizationId
        //   );
        // }
        // await dispatch.organizationUnit.showResourecePane(null);
        // await dispatch.organizationTab.getOrgnizationUnitAsync(
        //   payload.organizationId
        // );
        // await dispatch.users.storeUnitId(payload.parentOrganizationId);
        // await dispatch.organizationTab.getUsersTreeAsync({
        //   id: payload.organizationId,
        //   accountId: payload.accountId,
        // });
        // toastr.success("Message", payload.name + " Team deleted successfully");
        // return dispatch(
        //   push(
        //     `/app/${payload.accountId}/_ws/${payload.organizationId}/_cm/team/${payload.parentOrganizationId}`
        //   )
        // );
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        toastr.error("Message", "Failed to delete ");
        throw err;
      }
    },
    async updateOrgTimeZone(payload) {
      try {
        if (payload.organizationId) {
          await organizationService.patch(payload.organizationId, {
            timeZone: payload.timeZone,
          });
          dispatch.app.updateSelectedOrgTimeZone(payload.timeZone);
        }
      } catch (err) {
        toastr.error("Message", "Error updating activity1");
        throw err;
      }
    },
    clearOrganizationUnit() {
      dispatch.organizationUnit.clear();
    },
    showResourecePane(payload) {
      dispatch.organizationUnit.showResourecePaneFlagSet(payload);
    },

    landingPageFlagSet(payload) {
      dispatch.organizationUnit.setLadingPage(payload);
    },
    async getOrganizationCount(payload) {
      const OrgSummary = await workspaceOwnerDashboardCountervice.get(
        payload.organizationId
      );
      dispatch.organizationUnit.setOrganizationCountData(OrgSummary);
    },

    async myCommunityDashboardCount(payload) {
      const OrgSummary = await managerDashboardCountService.find({
        query: {
          accountId: payload.accountId,
          organizationId: payload.organizationId,
        },
      });
      dispatch.organizationUnit.setOrganizationCountData(OrgSummary);
    },

    async checkSuborganizationBeforeDelete(payload) {
      try {
        await checkSuborganizationBeforeDeleteService.get(payload);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        throw err;
      }
    },
    showDeleteDisabled(payload) {
      dispatch.organizationUnit.showDeleteDisabledBtn(payload);
    },

    async setDefaultWorkspace(payload, state) {
      try {
        let organizationList = Object.assign(
          {},
          state.account.organizationList
        );
        let AUWs = await setDefaultWorkspaceService.patch(
          payload.organizationId,
          payload
        );

        // Updating User, organizationList and selectedOrganization in state
        dispatch.account.setWorkspacesTotalCount(AUWs.organizations.length);

        for (let index = 0; index < organizationList.data.length; index++) {
          const workspace = organizationList.data[index];
          if (workspace.id.toString() === payload.organizationId.toString()) {
            workspace.default = payload.default;
          } else {
            workspace.default = false;
          }
        }
        dispatch.account.setOrganizationList(
          Object.assign({}, organizationList)
        );

        if (AUWs._id) {
          AUWs.organizations.forEach((org) => {
            if (
              org &&
              org.id &&
              state.app.selectedOrganisation &&
              state.app.selectedOrganisation.id &&
              org.id.toString() === state.app.selectedOrganisation.id.toString()
            ) {
              dispatch.app.setSelectedOrganisationData(org);
            }
          });
          let payload = {
            accountUserWorkspaces: AUWs.organizations,
            selectedWorkspace: state.app.selectedOrganisation,
          };
          dispatch.app.setupNewOrganization(payload);
        } else {
          let payload = {
            accountUserWorkspaces: state.app.organizations,
            selectedWorkspace: state.app.selectedOrganisation,
          };
          dispatch.app.setupNewOrganization(payload);
        }
      } catch (error) {
        // console.warn("Error while setting default workspace - ", error);
        throw error;
      }
    },

    async isWorkspaceActiveCheck(payload, state) {
      try {
        const hasRequiredRoles = payload.appState.organizations.some(org => 
          org.id === payload.data._id && 
          org.role === "workspaceOwner" &&
          payload.appState.user.accounts.some(account =>
            account.id === payload.data.accountId && 
            account.role === "customerAdmin"
          )
        );

        const isWorkspaceActive = !hasRequiredRoles &&
          payload.data.active === false && 
          (payload.data._id === payload.appState.selectedOrganisation.id);

        if(isWorkspaceActive) {
          dispatch.app.setIsActiveModal(true);
        }

        let isWorkspaceActiveCheckDashboard = !hasRequiredRoles &&
          payload.data.active === false && 
          (payload.appState.currentContext === "acc-home");

        if(isWorkspaceActiveCheckDashboard){
          console.log("isWorkspaceActiveCheckDashboard",isWorkspaceActiveCheckDashboard);
          toastr.confirm(
            <div className="confirmMessage">
              <h3>Workspace {payload.data.name} Deactivated</h3>
              <p>Workspace {payload.data.name} has been deactivated by the Account Owner.
              Contact the Account Owner to reactivate your workspace.</p>
            </div>,
            {   
              onOk: async () => {
                dispatch(window.location.reload());
                isWorkspaceActiveCheckDashboard = false;
              },
              disableCancel: true,
              closeOnClickOutside: false,
              closeButton: false
            }
          );
        }
      } catch (error) {
        throw error;
      }
    },

    async setActiveWorkspace(payload, state) {
      try {
        let organizationList = Object.assign(
          {},
          state.account.organizationList
        );
        for (let index = 0; index < organizationList.data.length; index++) {
          let workspace = organizationList.data[index];
          if (workspace.id.toString() === payload.organizationId.toString()) {
            if (payload.active === false) {
              workspace.default = false;
              payload.default = false;
              workspace.active = payload.active;
              await setActiveWorkspaceService.patch(
                payload.organizationId,
                payload
              );
              await setDefaultWorkspaceService.patch(payload.organizationId, {
                ...payload,
                fromActive: true,
              });
            } else {
              workspace.active = payload.active;
              await setActiveWorkspaceService.patch(
                payload.organizationId,
                payload
              );
            }
          }
        }
        dispatch.account.setOrganizationList(
          Object.assign({}, organizationList)
        );
      } catch (error) {
        // console.warn("Error while setting active workspace - ", error);
        throw error;
      }
    },

    async deleteWorkspace(payload) {
      try {
        await organizationService.remove(payload.organizationId);
        const accountUserWorkspaces = await accountUserWorkspacesService.find({
          query: {
            accountId: payload.accountId,
            accountUserId: payload.accountUserId,
          },
        });
        dispatch.account.setWorkspacesTotalCount(
          accountUserWorkspaces.data[0].organizations.length
        );

        if (accountUserWorkspaces.data.length > 0) {
          let payload = {
            accountUserWorkspaces: accountUserWorkspaces.data[0].organizations,
          };
          dispatch.app.setupNewOrganization(payload);
        } else {
          dispatch.app.setupNewOrganization([]);
        }
        dispatch.app.setAccountSubscriptionDetails(payload.accountId);

        toastr.success("Message", "Workspace deleted successfully.");
      } catch (e) {
        //console.warn("Error while deleteing workspace - ", e);
        toastr.error("Message", "Failed to deleted workspace.");
        throw e;
      }
    },

    async updateWorkspace(payload, state) {
      try {
        let organizationList = state.account.organizationList;
        let updateData = {
          name: payload.data.name,
          slug: payload.data.slug,
          oldName: payload.data.oldName,
        };
        await organizationService.patch(payload.organizationId, {
          $set: {
            name: payload.data.name,
            slug: payload.data.slug,
            oldName: payload.data.oldName,
          },
        });

        for (let index = 0; index < organizationList.data.length; index++) {
          const workspace = organizationList.data[index];
          if (workspace.id.toString() === payload.organizationId.toString()) {
            workspace.name = payload.data.name;
            workspace.slug = payload.data.slug;
          }
        }
        dispatch.account.setOrganizationList(organizationList);
      } catch (err) {
        dispatch.app.setOrgCreationError(err);
        throw err;
      }
    },
    async updateOrganization(payload) {
     await organizationService.patch(payload._id, { $set: { ...payload } });
    },

    async updateWorkspaceInState(payload, state) {
      if (state.app.user._id.toString() === payload.accountUserId.toString()) {
        let updatedOrgName = {
          accountUserWorkspaces: payload.organizations,
        };
        await dispatch.app.setupNewOrganization(updatedOrgName);
      }
    },

    async getSubOrgByIdAsync(id) {
      try {
        const subOrgResult = await subOrganizationService.get(id);
        dispatch.organizationUnit.setSelectedSubOrg(subOrgResult);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
      }
    },

    async getOrgByIdAsync(id) {
      try {
        const OrgResult = await organizationService.get(id);
        dispatch.organizationUnit.setSelectedSubOrg(OrgResult);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
      }
    },

    isUserAvailable(payload, state) {
      try {
        dispatch.users.updateState(payload.data.createdBy);
        dispatch.organizationUnit.showResourecePane("User");
        dispatch.lifeCycle.splitAt("60%");
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
      }
    },
    async updateRole(payload, state) {
      try {
        let result = await changeRoleTeamService.patch(payload._id, payload);
      } catch (err) {}
    },

    async onChangeRedirectToWorkspace(payload, state) {
      let accountOwner = await accountUsersService.get(
        payload.appState.selectedAccount.ownerId
      );

      let workspaceName = payload.data.selectedValue;
      workspaceName = workspaceName.slice(0, 9) + " " + workspaceName.slice(9);
      let message = (
        <div className="confirmMessage">
          <h3>Role Changed</h3>
          <label>{payload.appState.selectedOrganisation.name}</label>

          <p>
            {accountOwner.firstName + " " + accountOwner.lastName + " "}
            has promoted you as{" "}
            {" " +
              workspaceName.charAt(0).toUpperCase() +
              workspaceName.slice(1)}
          </p>
        </div>
      );
      if (payload.data._id === payload.appState.user._id) {
        if (payload.appState.currentContext === "acc-home") {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.app.setOrganisation({});
              return dispatch(window.location.reload());
            },
            disableCancel: true,
          });
        } else {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.app.setOrganisation({});
              return dispatch(
                push(
                  "/app/" + payload.appState.selectedAccount._id + "/dashboard"
                )
              );
            },
            disableCancel: true,
          });
        }
      }
    },
    async getSuborganizationToExport(payload, state) {
      try {
        let queryObj = {};
        if (payload.teamId == state.app.selectedOrganisation.id) {
          queryObj = { query: { parentOrganizationId: payload.teamId } };
        } else {
          queryObj = { query: { _id: payload.teamId } };
        }
        let suborgToExport = await suborganizationsExportService.find(queryObj);
        toastr.success("Message", payload.name + " team exported successfully");
        dispatch.organizationUnit.getTeamDataToExport(suborgToExport);
      } catch (error) {
        console.log("Error in exporting suborganization ", error);
        toastr.error("Message", "Error in exporting " + payload.name + " team");
      }
    },
    async importTeam(payload) {
      try {
        let importedTeam = await suborganizationsImportService.create({
          data: payload,
        });
        if (importedTeam.data.name != undefined) {
          toastr.success(
            "Message",
            importedTeam.data.name + " team imported successfully"
          );
        } else {
          toastr.warning("Message", " Skipped 1 record with duplicate name");
        }
        dispatch.organizationTab.getOrgnizationUnitAsync(
          payload.organizationId
        );
        dispatch.organizationUnit.getAssignedSubOrgAsync({
          organizationId: payload.organizationId,
          accountId: payload.accountId,
        });
      } catch (error) {
        console.log("Error in importing suborganization ", error);
        toastr.error("Message", "Error in importing team");
      }
    },
    async fetchTeams(payload, state) {
      let query = {
        organizationId: payload.organizationId,
        accountId: payload.accountId,
        "members.accountUserId": state.app.user._id,
        $populate: [
          {
            path: "suborganizations",
            populate: "suborganizations",
            select: "_id name",
          },
        ],
      };
      const teamList = await subOrganizationService.find({
        query: query,
      });
      dispatch.organizationUnit.setTeamList(teamList.data);
    },
    async getOrganizationTeams(payload) {
      try {
        let teams = await organizationService.get(payload._id, {
          query: {
            $select: ["_id", "name", "subOrganizations"],
            $populate: [
              {
                path: "subOrganizations",
                select: "_id name",
              },
            ],
          },
        });
        dispatch.organizationUnit.getOrgTeams(teams);
      } catch (error) {
        console.log("Error in getting teams under organization ", error);
      }
    },
    async getOrganizationUsers(payload) {
      try {
        let org = await organizationService.get(payload._id, {
          query: {
            $select: ["_id", "name", "users"],
            $populate: [
              {
                path: "users.accountUserId",
                select: "_id firstName lastName email profilePic",
              },
            ],
          },
        });
        dispatch.organizationUnit.setOrgUsers(org.users);
      } catch (error) {
        console.log("Error in getting users under organization ", error);
      }
    }
  },
};